module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Gc-Ha-Ia-Gc.a3201eac.png";